<template>
    <div class="container wizard-content mx-auto mt-2 mb-12">
        <div class="space flex flex-col">
            <slot></slot>
        </div>
    </div>
</template>

<script>
export default {};
</script>
